module.exports = __webpack_public_path__ + "static/media/fuel-station.c52ebc03.svg";